import styled from 'styled-components';

export { StepContainer, StepIndicator, StepHeader, StepTitle, StepDescription } from '../step-shared/StepShared.styles.js';

export const ShowcaseContainer = styled.div`
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 16px;
    box-sizing: border-box;
    overflow: hidden;
    width: 100%;
    max-width: 740px;
`;

export const ShowcaseGif = styled.img`
    display: block;
    height: auto;
    max-width: 100%;
    object-fit: contain;
`;
